<template>
    <div>
        <button
            class="fixed bottom-6 right-6 w-16 h-16 bg-cover bg-center bg-no-repeat rounded-full transition-all duration-300 z-50 active:scale-95 flex items-center justify-center disabled:opacity-60 disabled:brightness-75"
            style="background-image: url('vamoos-icon.png')"
            title="Sincronizar con Vamoos"
            @click="openVamoos"
            :disabled="loading"
            :aria-busy="loading"
        >
            <span v-if="loading" class="absolute w-7 h-7 border-4 border-gray-200 border-t-blue-500 rounded-full animate-spin"></span>
        </button>
    </div>
</template>

<script>
const api = window.api;
export default {
    name: 'VamoosButton',
    props: {
        fit: {
            type: Boolean,
            default: false
        },
        groups: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        async openVamoos() {
            if (this.loading) return;
            this.loading = true;
            try {
                let hotels = []
                if (!this.$store.state.tripBookingHotels) {
                    const queries = { ...this.$route.query };
                    if (this.fit) {
                        queries.fit = this.fit;
                    }
                    const endpoint = this.groups
                        ? '/api/groups/group_booking_hotels'
                        : '/api/tpsql/trip_booking_hotels';
                    let res = await api.get(endpoint, queries);
                    if (res) {
                        this.$store.commit('setBookingHotels', res);
                        hotels = this.$store.getters.cities;
                    }
                }
                else {
                    hotels = this.$store.getters.cities;
                }
                const dayList = this.$store.getters.dayList;
                const cityLocations = this.$store.getters.bookingCities;

                const data = {
                    dayList: dayList ? dayList : [],
                    language: this.$store.state.lang ? this.$store.state.lang : 'en',
                    cityLocations: cityLocations ? cityLocations : [],
                    hotels: hotels ? hotels : [],
                    refCode: this.$store.state.reference ? this.$store.state.reference : '0',
                    background: this.$store.state.coverImg ? this.$store.state.coverImg : null,
                    name: this.$store.state.tripName ? this.$store.state.tripName : 'Trip',
                    gr: this.$store.state.grUser ? this.$store.state.grUser : null
                }
                await api.syncVamoos(data);
            } catch (e) {
                console.error(e);
            } finally {
                this.loading = false;
                console.log("ciao");
            }
        }
    }
}
</script>
